import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import imageNotAvailable from '../images/image_not_available.png';
import { BorderAllRounded } from '@material-ui/icons';
class ImageLoader extends Component {
  static defaultProps = {
    width: '60px',
    height: '60px',
    fallbackSrc: imageNotAvailable,
    className: '',
    id: '',
    onClick: () => {},
    onLoad: () => {}
  };

  handleError = (e) => (e.target.src = this.props.fallbackSrc);

  render() {
    return (
      <Image
        src={this.props.src || this.props.fallbackSrc}
        width={this.props.width}
        height={this.props.height}
        onClick={this.props.onClick}
        onError={this.handleError}
        onLoad={this.props.onLoad}
        style={{borderRadius: 8}}
      />
    );
  }
}

export default ImageLoader;
